function validate(value){
    var str = value.toString().replace(/\s/g, '');
    return str.length === 9 && /^[679]{1}[0-9]{8}$/.test(str);
}

exports.validate = validate;